import { setNotification, resetNotification } from "../../rdx/slices/Notification";
import * as jsrsasign from 'jsrsasign';

export const removeDuplicatesFromArray = (arr: Array<any>) => {
  if (!Array.isArray(arr)) {
    console.error(`array expected, ${typeof arr} provided`)
    return
  }
  return [...new Set(arr)]
}

export const removeDuplicateObjectFromArray = (
  array: Array<any>,
  key: string
) => {
  let filteredArray = array?.filter(
    (obj, index, self) => index === self.findIndex((el) => el[key] === obj[key])
  )
  return filteredArray
}

export const getRandomNumberInRange = (lower = 0, upper = 10) => {
  if (isNaN(lower) || isNaN(upper)) {
    console.error("lower and upper must be valid numbers")
    return
  }
  lower = Math.ceil(lower)
  upper = Math.floor(upper)
  return Math.floor(Math.random() * (upper - lower + 1)) + lower
}

export const shorten = (text: any, length = 10, ellipsisCount = 3) => {
  if (!(typeof text === "string" || text instanceof String)) {
    console.error(`expecting a string, ${typeof text} provided`)
    return ""
  }
  if (isNaN(length) || isNaN(ellipsisCount)) {
    console.error("length and ellipsisCount must be valid numbers")
    return
  }

  if (text.length <= length) {
    return text
  }
  const ellipsis = Array.from(Array(ellipsisCount))
    .map(() => ".")
    .join("")
  return `${text.substr(0, length)}${ellipsis}`
}

export const debounce = (func: any, timeout = 2500) => {
  if (typeof func !== "function") {
    console.error(`func must be a valid function, ${typeof func} provided`)
    return
  }
  let timer: NodeJS.Timeout
  return (...args: Array<any>) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export const measureTime = (func: any, label = "default") => {
  if (typeof func !== "function") {
    console.error(`func must be a valid function, ${typeof func} provided`)
    return
  }
  console.time(label)
  func()
  console.timeEnd(label)
}

export const slugify = (text: any) => {
  if (!(typeof text === "string" || text instanceof String)) {
    console.error(`string expected, ${typeof text} provided`)
    return text
  }
  return text
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "")
}

export const camelToSnakeCase = (text: any) => {
  if (!(typeof text === "string" || text instanceof String)) {
    console.error(`string expected, ${typeof text} provided`)
    return text
  }
  return text.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

export const snakeToCamelCase = (text: any) => {
  if (!(typeof text === "string" || text instanceof String)) {
    console.error(`string expected, ${typeof text} provided`)
    return text
  }
  text
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", "")
    )
}

export const isValidEmail = (email: any) => {
  if (!(typeof email === "string")) {
    console.error(`string expected, ${typeof email} provided`)
    return false
  }
  const expression = /\S+@\S+\.\S+/
  return expression.test(email)
}

export const bytesToSize = (bytes: number) => {
  if (bytes === 0) return "0 B"

  const k = 1024
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return (bytes / Math.pow(k, i)).toPrecision(3) + " " + sizes[i]
}

//123456789 => 123,456,789
export const numberToStringWithComma = (number: number) => {
  // convert number to string
  let str = String(number)

  let s = ""
  let count = 0
  for (let i = str.length - 1; i >= 0; i--) {
    s = str[i] + s
    count++
    // add a comma to every three numbers
    if (count % 3 === 0 && i !== 0) {
      s = "," + s
    }
  }
  return s
}

export const some = (predicate: any, array: Array<any>) =>
  array.reduce((acc, value) => acc || predicate(value), false)

export const all = (predicate: any, array: Array<any>) =>
  array.reduce((acc, value) => acc && predicate(value), true)

export const none = (predicate: any, array: Array<any>) =>
  array.reduce((acc, value) => !acc && !predicate(value), false)

export const map = (transformany: any, array: Array<any>) =>
  array.reduce((newArray, item) => {
    newArray.push(transformany(item))

    return newArray
  }, [])

export const filter = (predicate: any, array: Array<any>) =>
  array.reduce((newArray, item) => {
    if (predicate(item) === true) {
      newArray.push(item)
    }

    return newArray
  }, [])

export const reject = (predicate: any, array: Array<any>) =>
  array.reduce((newArray, item) => {
    if (predicate(item) === false) {
      newArray.push(item)
    }

    return newArray
  }, [])

export const find = (predicate: any, array: Array<any>) =>
  array.reduce((result, item) => {
    if (result !== undefined) {
      return result
    }

    if (predicate(item) === true) {
      return item
    }

    return undefined
  }, undefined)

export const partition = (predicate: any, array: Array<any>) =>
  array.reduce(
    (result, item) => {
      const [list1, list2] = result

      if (predicate(item) === true) {
        list1.push(item)
      } else {
        list2.push(item)
      }

      return result
    },
    [[], []]
  )

export const pluck = (key: string | number, array: Array<any>) =>
  array.reduce((values, current) => {
    values.push(current[key])

    return values
  }, [])

export const stripHTMLTags = (str: string) => str.replace(/<[^>]*>/g, "")
export const PaginationOptions = [5,10,15,25]
const inBrowser = typeof window !== "undefined"

// get user agent
const UA = inBrowser && window.navigator.userAgent.toLowerCase()

// detect browser
export const isIE = UA && /msie|trident/.test(UA)
export const isIE9 = UA && UA.indexOf("msie 9.0") > 0
export const isEdge = UA && UA.indexOf("edge/") > 0
export const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge
export const isPhantomJS = UA && /phantomjs/.test(UA)
export const isFF = UA && UA.match(/firefox\/(\d+)/)

// detect OS
export const isAndroid = UA && UA.indexOf("android") > 0
export const isIOS = UA && /iphone|ipad|ipod|ios/.test(UA)

//filtering the permissions based on the page
export const getPermissions = (url: string) => {
  // const permissions = JSON.parse(localStorage.getItem('permissions') as string);
  const permissions = JSON.parse(localStorage.getItem('userscope') as string);
  // const roleScope = JSON.parse(localStorage.getItem('userscope') as string);
  // const permissions = roleScope[0]?.scope;
  let pageWisePermissions = [];
  if(url){
    switch(true) {
      case url.includes('/process-definitions'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'AIM';
          });
          break;

      case url.includes('/process-instances'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'AIMI';
          });
          break;

      case url.includes('/process-templates'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'ProcessTemplate';
          });
          break;
      case url.includes('/api-integrator'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'ApiIntegrator';
          });
          break;
      case url.includes('/view-tasks'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'Task';
          });
          break;
      case url.includes('/ot-assests'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'OTAssets';
          });
          break;
      case url.includes('/configure-adapters') || url.includes('/view-adapters'):
          pageWisePermissions = permissions?.filter((perm: any) => {
            return perm?.split(':')[0] === 'ACL';
          });
          break;
      case url.includes('/manage-alerts') || url.includes('/view-alerts'):
        pageWisePermissions = permissions?.filter((perm: any) => {
          return perm?.split(':')[0] === 'Alert';
        });
        break;
      case url.includes('/createdatamodel') || url.includes('/viewdatamodel'):
        pageWisePermissions = permissions?.filter((perm: any) => {
          return perm?.split(':')[0] === 'ODS';
        });
        break;
      default:
    }
  }
  return pageWisePermissions;
}

export const getPermissionAccess = (operationsArray:any) => {
  if(operationsArray.length > 0){
    const dynamicPrefix = operationsArray.length > 0 ? operationsArray[0].split(':')[0] : '';
    const allOperations = ["Configure", "View", "Update", "Delete", "Draft"];
    const operationsObject = allOperations.reduce((obj:any, operation) => {
      obj[operation] = operationsArray?.includes(`${dynamicPrefix}:${operation}`);
      return obj;
    }, {});
    return operationsObject;
  }else{
    const sample = {Configure: true, View: true, Update: true, Delete: true, Draft: true};
    return sample;
  }
}

const roleToUrlMapping:any = {
  'AIM': '$process-definitions',
  'AIMI': '$process-instances',
  'ProcessTemplate': '$process-templates',
  'ApiIntegrator': '$api-integrator',
  'Task': ['$view-tasks'],
  'OTAssets': '$ot',
  'ACL': ['$configure-adapters', '$view-adapters'],
  'Alert': ['$manage-alerts', '$view-alerts', '$create-alerts'],
  'ODS': ['$create-data-model', '$view-data-model'],
  'LEM': ['$view-instace-logs', '$view-system-logs']
};

const rolesToUrlMapping:any = {
  'AIM:Configure': '$process-definitions',
  'AIM:View': '$process-definitions',
  'AIM:Update': '$process-definitions',
  'AIM:Delete': '$process-definitions',
  'AIMI:Configure': '$process-instances',
  'AIMI:View': '$process-instances',
  'AIMI:Update': '$process-instances',
  'AIMI:Delete': '$process-instances',
  'ProcessTemplate:Configure': '$process-templates',
  'ProcessTemplate:View': '$process-templates',
  'ProcessTemplate:Delete': '$process-templates',
  'CredentialManager:Configure': '$credential-manager',
  'CredentialManager:View': '$credential-manager',
  'CredentialManager:Update': '$credential-manager',
  'CredentialManager:Delete': '$credential-manager',
  'ACL:Configure': '$configure-adapters',
  'ACL:View': '$view-adapters',
  'ACL:Update': '$configure-adapters',
  'ACL:Delete': '$configure-adapters',
  'ApiIntegrator:Configure': '$api-integrator',
  'ApiIntegrator:View': '$api-integrator',
  'ApiIntegrator:Update': '$api-integrator',
  'ApiIntegrator:Delete': '$api-integrator',
  'ODS:Configure': '$create-data-model',
  'ODS:Update': '$create-data-model',
  'ODS:Draft': '$create-data-model',
  'ODS:Delete': '$create-data-model',
  'ODS:View': '$view-data-model',
  'Alert:Configure': ['$manage-alerts', '$create-alerts'],
  'Alert:View': '$view-alerts',
  'Task:Update': '$update-tasks',
  'Task:View': '$view-tasks',
  'OTAssets:Configure': '$ot',
  'OTAssets:View': '$ot',
  'OTAssets:Update': '$ot',
  'OTAssets:Delete': '$ot',
  'LEM:View': '$view-instace-logs', 
  'LEMS:View': '$view-system-logs',
}

export const decodeJwtWithJsrs = (token: any) => {
  try {
    const decodedToken: any = jsrsasign.KJUR.jws.JWS.parse(token);
    return decodedToken?.payloadObj;
  } catch (error) {
    console.log(error, "errorr");
  }
}

export const getCookie = (cname: string) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie || "");
  const cookies = decodedCookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === " ") cookie = cookie.substring(1);
    if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
  }

  return "";
}

export const modGetAllowedUrls = (roles:any) => {
  const allowedUrls = new Set();
     roles?.forEach((role: any, index:number) => {
        const urls = rolesToUrlMapping?.[role];
        if(urls!==undefined){
          if (Array.isArray(urls)) {
            urls.forEach(url => allowedUrls?.add(url));
          } else {
              allowedUrls?.add(urls);
          }
        }
     });
     return allowedUrls;
}

export const handleApiRequest = async (requestFunction: () => Promise<any>, dispatch: any) => {
  try {
    return await requestFunction();
  } catch (error:any) {
    if (error?.response) {
      // Dispatch the setNotification action
      dispatch(setNotification({
        toastMessage: error?.response?.data?.Message || "Unauthorized access or Forbidden",
        toastType: "error",
        showToast: true,
      }));
      setTimeout(() => {
        dispatch(resetNotification());
      }, 4000);
    }

    return error?.response;
  }
};

//For the purpose I have commented this code
// const decodedToken = JSON.parse(atob(String(localStorage.getItem('access_token')).split(".")[1]));
// const response = await AdapterAPI.get(`/Adapter`, {
    //   page,
    //   pageSize,
    //   searchTerm,
    //   sortDirection,
    //   orderBy,
    //   adapterstatus,
    //   adapter_service_status
    // });
    // return response
  // 	return await ProcessDefinitionAPI.get(`/v1/process-definitions/v2`, {
		// 		page,
		// 		pageSize,
		// 		sortDirection,
		// 		searchTerm: searchTerm,
		// 		isDraft,
		// 		orderBy,
		// }) as PagedList<ProcessInstanceDefinitions>;
// export const getAllowedUrls = (roles:any) => {
//   const allowedUrls = new Set();
//      roles.forEach((role: any) => {
//         const urls = roleToUrlMapping?.[role];
//         if (Array.isArray(urls)) {
//            urls.forEach(url => allowedUrls?.add(url));
//         } else {
//            allowedUrls?.add(urls);
//         }
//      });
//      return allowedUrls;
// }

  //  const permissions = [
  //     "AIM:Configure",
  //     "AIM:View",
  //     "AIM:Update",
  //     "AIM:Delete",
  //     "AIMI:Configure",
  //     "AIMI:View",
  //     "AIMI:Update",
  //     "AIMI:Delete",
  //     "ProcessTemplate:Configure",
  //     "ProcessTemplate:View",
  //     "ProcessTemplate:Delete",
  //     "ACL:Configure",
  //     "ACL:View",
  //     "ACL:Update",
  //     "ACL:Delete",
  //     "ApiIntegrator:Configure",
  //     "ApiIntegrator:View",
  //     "ApiIntegrator:Update",
  //     "ApiIntegrator:Delete",
  //     "ODS:Configure",
  //     "ODS:Update",
  //     "ODS:Delete",
  //     "ODS:View",
  //     "Alert:Configure",
  //     "Alert:View",
  //     "Task:Update",
  //     "Task:View",
  //     "OTAssets:Configure",
  //     "OTAssets:View",
  //     "OTAssets:Update",
  //     "OTAssets:Delete",
  //     "LEM:View",
  //     "LEMS:View"
  // ];
   
//   const uniqueScopes = useMemo(() => {
//    if (!permissions) {
//       return [];
//    }

//    const filter = permissions.map((role: any) => {
//       return role?.split(':')[0];
//    });

//    return [...new Set(filter)];
// }, [permissions]);